import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #F7F7F7;
  border-radius: 15px;
  margin-top: 10px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  gap: 10px;
  margin-bottom: 15px;
`

export const BottomRow = styled(Row)`
  margin-bottom: 10px;
`

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`

export const Input = styled(BaseInput)`
  width: 100%;
`

export const SubTitle = styled.h3`
  font-size: 15px;
  font-weight: 500;
  margin: 0px 0px 10px;
`

export const Label = styled.label`
  margin-bottom: 5px;
  color: #777777;
`

export const InfoText = styled.p`
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`

export const WarningText = styled.p`
  margin: 3px 0px 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 200;
  line-height: 18px;
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin-bottom: 15px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`
